import { filter as _filter, includes, map } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { isCategory, resolveNodeId, resolveNodeParentId, } from '../../../../modules/Organization/OrganisationGroups/FacilityManagement/AssetGroups/AssetCategoryTree';
import assetCategoryTree from '../../../../modules/Organization/OrganisationGroups/FacilityManagement/AssetGroups/data/assetCategoryTree.graphql';
import useAssetGroupName from '../../../data/hooks/useAssetGroupName';
import useTranslation from '../../utils/Translations/useTranslation';
import GqlStaticTreeSelector from './GqlStaticTreeSelector';
import Statuses from '../../../../model/Statuses';
import Button from '../Button';
import { isRootNode } from '../../dataViews/DynamicTree';
const AssetCategorySelector = ({ onChange, organisationGroupId, filter, assetGroupId, availableOptions, isDisabled, disabled, ...rest }) => {
    const { t } = useTranslation();
    const _assetGroupId = useMemo(() => assetGroupId || (filter === null || filter === void 0 ? void 0 : filter.assetGroupId), [
        assetGroupId,
        filter,
    ]);
    const assetGroupName = useAssetGroupName(organisationGroupId, _assetGroupId);
    const visibleIds = useMemo(() => map(availableOptions, 'id'), [
        availableOptions,
    ]);
    const nodeIsVisible = useCallback(node => isCategory(node) && visibleIds.length
        ? includes(visibleIds, node.id)
        : true, [visibleIds]);
    const _disabled = useMemo(() => {
        if (isDisabled) {
            return isDisabled(filter);
        }
        if (disabled !== undefined) {
            return disabled;
        }
        return !organisationGroupId || !_assetGroupId;
    }, [organisationGroupId, _assetGroupId, isDisabled, filter, disabled]);
    const renderNodeAddons = (node, meta) => {
        const { handleClear } = meta;
        const handleClearFn = e => {
            handleClear();
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        };
        const addons = [];
        if (isRootNode(node)) {
            addons.push(<Button additionClasses="text-primary no-padding-top no-padding-bottom" buttonStyle="link" onClick={handleClearFn}>
          {t('Clear')}
        </Button>);
        }
        return addons;
    };
    return (<GqlStaticTreeSelector hasSyntheticRootNode adapter={{
        renderNodeAddons,
        nodeIsLeaf: isCategory,
        resolveNodeParentId,
        resolveNodeId,
    }} disabled={_disabled} gql={assetCategoryTree} gqlSkip={!organisationGroupId || !_assetGroupId || !!disabled} gqlVariables={{
        organisationGroupId,
        assetGroupId: _assetGroupId,
        status: Statuses.Active.value,
    }} hasClearButton={false} plugins={{
        nodeIsVisible,
    }} selectionFilter={selectionFilter} syntheticRootNodeName={assetGroupName} title={t('Asset category')} tree="AssetCategorySelector" onChange={onChange} {...rest}/>);
};
export default AssetCategorySelector;
export function selectionFilter(assetGroups) {
    return _filter(assetGroups, isCategory);
}
